import { useGetAllOrganisationsQuery } from './redux/organisationApiSlice';

import { GridColDef } from '@mui/x-data-grid-pro';
import { t } from "i18next";
import { useMemo } from 'react';
import DatagridWrapper, { DataGridId } from '../../components/DatagridWrapper';
import { PaginationQueryPackage } from '../../models/API/QueryParams/PaginationQueryPackage';
import { roleToString } from '../../models/User';
import { useGetAllUserQuery } from '../UserApi/redux/userApiSlice';
import { OrganisationContactLabel } from '../../models/OrganisationContact';

export const MailList = () => {
    return (<MailListContent />)
}

const MailListContent = () => {
    const organisations = useGetAllOrganisationsQuery({
        pagination: new PaginationQueryPackage()
    });

    const users = useGetAllUserQuery({
        pagination: new PaginationQueryPackage()
    });

    const mailList = useMemo(() => {
        if (organisations.data === undefined || users.data === undefined) return []
        const orgManagers = organisations.data.flatMap(org =>
            org.contacts?.filter(contact => contact.label == OrganisationContactLabel.ORGANISATIONAL_MANAGER)
                .map(contact => new MailInfo(contact.email, [t("Organisational manager")], org.name ? [org.name] : [])) ?? [])
        const serviceDesks = organisations.data.flatMap(org =>
            org.contacts?.filter(contact => contact.label == OrganisationContactLabel.SERVICE_DESK)
                .map(contact => new MailInfo(contact.email, [t("Servicedesk")], org.name ? [org.name] : [])) ?? [])

        const userMails = users.data
            .map(user => new MailInfo(user.email, [t("User in portal") + " - " + t(roleToString(user.role))], user.organisation?.name ? [user.organisation?.name] : []))

        const combinedMails = orgManagers.concat(serviceDesks).concat(userMails)
            .filter(mailInfo => mailInfo.email !== undefined && mailInfo.email !== "")
            .reduce((acc: Record<string, MailInfo>, entry: MailInfo) => {
                const existing = acc[entry.email ?? ""]
                const combinedRoles = new Set([...entry.roles, ...(existing?.roles ?? [])])
                const combinedOrgNames = new Set([...entry.organisation_names, ...(existing?.organisation_names ?? [])])
                const combined = new MailInfo(entry.email, [...combinedRoles], [...combinedOrgNames])
                acc[entry.email ?? ""] = combined
                return acc
            }, {} as Record<string, MailInfo>)

        return Object.values(combinedMails)
    }, [organisations.data, users.data])


    const getColumns = () => {

        const columns: GridColDef[] = [
            { field: 'email', sortable: true, type: "string", headerName: t('Email'), flex: 2 },
            { field: 'roles', sortable: true, type: "string", headerName: t('Roles'), valueGetter: (roles: string[]) => roles.join(", "), flex: 2 },
            { field: 'organisation_names', sortable: true, type: "string", headerName: t('Organisation'), valueGetter: (orgs: string[]) => orgs.join(", "), flex: 2 },
        ];
        return columns
    }

    return (
        <>
            <DatagridWrapper
                dataGridId={DataGridId.MAIL_LIST}
                getRowId={(row) => row.email}
                autoHeight
                loading={organisations.isLoading}
                rows={mailList}
                columns={getColumns()}
                disableUuid
            />
        </>
    )
}

class MailInfo {
    email?: string;
    roles: string[];
    organisation_names: string[];

    constructor(email: string | undefined, roles: string[], organisation_names: string[]) {
        this.email = email;
        this.roles = roles;
        this.organisation_names = organisation_names;
    }
}

